import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * CTAButton - Botón de llamada a la acción reutilizable
 * 
 * @param {string} to - Ruta de destino (opcional, por defecto '/register')
 * @param {function} onClick - Función personalizada onClick (opcional)
 * @param {string} variant - Variante del botón: 'primary' | 'secondary' (opcional, por defecto 'primary')
 * @param {string} className - Clases CSS adicionales (opcional)
 * @param {React.ReactNode} children - Contenido del botón
 * @param {boolean} showSubtitle - Mostrar subtítulo debajo del botón (opcional, por defecto false)
 * @param {string} subtitleText - Texto del subtítulo (opcional)
 * @param {string} subtitleClassName - Clases CSS para el subtítulo (opcional)
 */
const CTAButton = ({
    to = '/register',
    onClick,
    variant = 'primary',
    className = '',
    children,
    showSubtitle = false,
    subtitleText = '',
    subtitleClassName = '',
    ...props
}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (to) {
            navigate(to);
        }
    };

    const baseButtonClasses = 'px-8 py-4 rounded-xl font-semibold text-base sm:text-lg transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5';

    const variantClasses = {
        primary: 'bg-primary-600 hover:bg-primary-700 text-white',
        secondary: 'bg-white hover:bg-gray-50 text-primary-600 border-2 border-primary-600 shadow-sm hover:shadow-md'
    };

    return (
        <div className="flex flex-col items-center">
            <button
                onClick={handleClick}
                className={`${baseButtonClasses} ${variantClasses[variant]} ${className}`}
                {...props}
            >
                {children}
            </button>
            {showSubtitle && subtitleText && (
                <p className={`mt-3 text-sm sm:text-base text-gray-600 ${subtitleClassName}`}>
                    {subtitleText}
                </p>
            )}
        </div>
    );
};

export default CTAButton;

